module.exports = __webpack_public_path__ + "static/media/CharacterIPA-IF.937052d2.png";